var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_1_7457)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9565 13.62C6.58316 13.62 6.24983 13.5667 5.9565 13.46C5.66316 13.3467 5.41316 13.1567 5.2065 12.89C4.99983 12.6233 4.84316 12.2633 4.7365 11.81C4.62983 11.35 4.5765 10.77 4.5765 10.07C4.5765 9.37 4.62983 8.79333 4.7365 8.34C4.84316 7.88 4.99983 7.51667 5.2065 7.25C5.41316 6.98333 5.66316 6.79667 5.9565 6.69C6.24983 6.57667 6.58316 6.52 6.9565 6.52C7.32983 6.52 7.65983 6.57667 7.9465 6.69C8.23983 6.79667 8.48983 6.98333 8.6965 7.25C8.90316 7.51667 9.05983 7.88 9.1665 8.34C9.27316 8.79333 9.3265 9.37 9.3265 10.07C9.3265 10.77 9.27316 11.35 9.1665 11.81C9.05983 12.2633 8.90316 12.6233 8.6965 12.89C8.48983 13.1567 8.23983 13.3467 7.9465 13.46C7.65983 13.5667 7.32983 13.62 6.9565 13.62ZM6.9565 12.62C7.26983 12.62 7.50316 12.5367 7.6565 12.37C7.8165 12.1967 7.92316 11.9433 7.9765 11.61C8.0365 11.27 8.0665 10.85 8.0665 10.35V9.83C8.0665 9.31667 8.0365 8.89 7.9765 8.55C7.92316 8.20333 7.8165 7.94667 7.6565 7.78C7.50316 7.60667 7.26983 7.52 6.9565 7.52C6.64983 7.52 6.41316 7.60667 6.2465 7.78C6.0865 7.94667 5.9765 8.2 5.9165 8.54C5.86316 8.87333 5.8365 9.29333 5.8365 9.8V10.32C5.8365 10.8267 5.86316 11.2533 5.9165 11.6C5.9765 11.94 6.0865 12.1967 6.2465 12.37C6.41316 12.5367 6.64983 12.62 6.9565 12.62ZM11.1418 13.5V12.5H12.7918V8.18H11.1318V7.43C11.3318 7.41 11.5651 7.36333 11.8318 7.29C12.1051 7.21 12.3818 7.11333 12.6618 7C12.9418 6.88667 13.1951 6.76667 13.4218 6.64H14.0218V12.5H15.5418V13.5H11.1418Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7457",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342F86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank1);
export default __webpack_public_path__ + "static/media/rank1.1893a3a20c197d1c450ed72b7566767c.svg";
export { ForwardRef as ReactComponent };